import { render, staticRenderFns } from "./FormCard.vue?vue&type=template&id=91355e7a&"
import script from "./FormCard.vue?vue&type=script&lang=js&"
export * from "./FormCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports